// Badge colour for a sync run's status in the history tables on the sync pages.
const BADGE_BY_STATUS = {
  success: 'stui-badge-green',
  failed:  'stui-badge-red',
  running: 'stui-badge-blue',
  dryrun:  'stui-badge-purple',
};

const syncStatusBadge = (status) => BADGE_BY_STATUS[String(status || '').toLowerCase()] || 'stui-badge-gray';

export default syncStatusBadge;
